import React from 'react';

const SearchBar = ({ 
  placeholder = 'Search Chemical Name', 
  searchQuery, 
  onSearchQueryChange, 
  performSearch,
  className = ''
}) => {
  const handleInput = (event) => {
    onSearchQueryChange(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      performSearch();
    }
  };

  return (
    <div className={`flex md:flex-row flex-col items-center justify-center w-full max-w-2xl mx-auto my-4 ${className}`}>
      <input
        type="text"
        value={searchQuery}
        placeholder={placeholder}
        className="flex-1 border border-gray-400 md:rounded-r-none rounded-lg p-2 shadow-sm focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition duration-200"
        onChange={handleInput}
        onKeyPress={handleKeyPress}
      />
      <button
        className="bg-blue-700 text-white md:rounded-l-none rounded-lg px-4 py-2 hover:bg-blue-800 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-600 transition duration-200 w-full md:w-auto mt-3 md:mt-0"
        onClick={performSearch}
      >
        Search
      </button>
    </div>
  );
};

export default SearchBar;
